import { FormSection } from "components/MainSectionTemplate/types";
import TwitterLink from "components/TwitterLink";
import WebsiteLink from "components/Website/WebsiteLink";
import React from "react";
import { getInstruction, ContactFormState, ContactFieldMetaData } from "shared/utils/fieldsHelper/contactFields";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import UrlInput from "components/urlinput";

export const socialsSection = (
  formState: ContactFormState,
  fieldMetaData: ContactFieldMetaData
): FormSection => {
  return {
    type: "collapsable",
    key: "socialsSection",
    title: "Socials",
    fields: [{
      ...fieldMetaData.twitter.fields(),
      key: "twitter",
      label: RESX.Contact.Twitter,
      render: () => <TwitterLink twitter={formState.twitter} />,
      isEmpty: !formState.twitter,
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxTwitterLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.twitter,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, { twitter: value });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.website.fields(),
      key: "website",
      label: RESX.GeneralLabels.Website,
      render: () => <WebsiteLink website={formState.website} />,
      inPageEdit: {
        render: ({ value, onChange, cancel, submit }) => (
          <UrlInput
            focusOnMount
            value={value}
            onValueChange={onChange}
            validatorKey="contactWebsite"
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxNetworkPathLength}
          />
        ),
        type: "confirmOrCancelButton",
        fullWidth: true,
        initialValue: formState.website,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, { website: value });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.facebook.fields(),
      key: "facebook",
      label: "Facebook",
      render: () => <WebsiteLink website={formState.facebook} />,
      inPageEdit: {
        render: ({ value, onChange, cancel, submit }) => (
          <UrlInput
            focusOnMount
            value={value}
            onValueChange={onChange}
            validatorKey="contactFacebook"
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.url.maxFacebookLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.facebook,
        fullWidth: true,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, { facebook: value });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.networkPath.fields(),
      key: "networkPath",
      label: RESX.Company.NetworkPath,
      render: () => <WebsiteLink website={formState.networkPath} />,
      inPageEdit: {
        render: ({ value, onChange, cancel, submit }) => (
          <UrlInput
            focusOnMount
            value={value}
            onValueChange={onChange}
            validatorKey="contactNetworkPath"
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxNetworkPathLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.networkPath,
        fullWidth: true,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, { networkPath: value });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }]
  }
}